<table>
    <tr class="header">
        <td class="row-title">
            <div class="table-buttons">
                <fui-context-button [title]="'wbo.common.button.clearAll'"
                                    (click)="changeAll(false)"></fui-context-button>
                <fui-context-button [title]="'wbo.common.button.selectAll'"
                                    (click)="changeAll(true)"></fui-context-button>
            </div>
        </td>
        <td class="col-title">Allow</td>
        <td class="col-title">Create</td>
        <td class="col-title">View</td>
        <td class="col-title">Update</td>
        <td class="col-title">Delete</td>
        <td></td>
    </tr>
    <tr class="entry" *ngFor="let p of privileges">
        <td class="row-title">{{'privileges.' + groupName + '.priv.' + p.name | translate}}</td>
        <td>
            <fui-checkbox-control *ngIf="p.supportAllow" [value]="p.allow"
                                  (valueChange)="onAllowChanged($event, p)"></fui-checkbox-control>
        </td>
        <td>
            <fui-checkbox-control *ngIf="p.supportCreate" [value]="p.create"
                                  (valueChange)="onCreateChanged($event, p)"></fui-checkbox-control>
        </td>
        <td>
            <fui-checkbox-control *ngIf="p.supportView" [value]="p.view"
                                  (valueChange)="onViewChanged($event, p)"></fui-checkbox-control>
        </td>
        <td>
            <fui-checkbox-control *ngIf="p.supportUpdate" [value]="p.update"
                                  (valueChange)="onUpdateChanged($event, p)"></fui-checkbox-control>
        </td>
        <td>
            <fui-checkbox-control *ngIf="p.supportDelete" [value]="p.delete"
                                  (valueChange)="onDeleteChanged($event, p)"></fui-checkbox-control>
        </td>
        <td></td>
    </tr>
</table>
